/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MappingType {
	ConvertToDirectLink = 1,
	ConvertToEmbeddedLink = 2,
	MapToPort = 3,
	BreakLink = -1,
}
